import { render, staticRenderFns } from "./post-preview.vue?vue&type=template&id=11ffcff4&"
import script from "./post-preview.vue?vue&type=script&lang=js&"
export * from "./post-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports